import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8a88020"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-panel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "江苏天鼎运营辅助平台", -1))

import LoginAccount from '@/views/login/components/login-account.vue'
import { onMounted, onBeforeUnmount, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'login-panel',
  setup(__props) {

const accountRef = ref<InstanceType<typeof LoginAccount>>()
const handleLoginClick = () => {
  accountRef.value?.loginAction()
}

const handleEnterKey = (event: KeyboardEvent) => {
  if (event.key === 'Enter') {
    handleLoginClick()
  }
}

// 在组件挂载后添加监听器
onMounted(() => {
  window.addEventListener('keydown', handleEnterKey)
})

// 在组件卸载前移除监听器
onBeforeUnmount(() => {
  window.removeEventListener('keydown', handleEnterKey)
})

const handleClick = () => {
  handleLoginClick()
}

return (_ctx: any,_cache: any) => {
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_tabs, {
      type: "border-card",
      stretch: ""
    }, {
      default: _withCtx(() => [
        _createVNode(LoginAccount, {
          ref_key: "accountRef",
          ref: accountRef
        }, null, 512)
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      type: "primary",
      class: "login-btn",
      onClick: handleLoginClick
    }, {
      default: _withCtx(() => [
        _createTextVNode("登录")
      ]),
      _: 1
    })
  ]))
}
}

})